// DS8.1.3
import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { ModalRoot, ModalRootProps } from '../../base';
import ModalDoNotShowAgain from './ModalDoNotShowAgain';
import HorizontalLayout from './layouts/HorizontalLayout';
import VerticalLayout from './layouts/VerticalLayout';

export interface Props
  extends Pick<
    ModalRootProps,
    | 'onRequestClose'
    | 'useFixedMobileHeight'
    | 'isOpen'
    | 'useTransparentOverlay'
    | 'shouldCloseOnOverlayClick'
    | 'bodyScrollLockOptions'
    | 'contentLabel'
    | 'className'
    | 'isFullscreen'
  > {
  variant: 'horizontal' | 'vertical' /* DS8.1.6 */;

  title: string;
  message?: React.ReactNode;
  footerButtons: React.ReactNode[];

  image?: React.ReactNode;
  className?: string;
  contentClassName?: string;

  /** Do not show again text and callback */
  doNotShowAgainText?: string;
  onDoNotShowAgainChange?: (value) => void;
}

const MessageModal: React.FC<Props> = ({
  variant,
  title,
  message,
  image,
  footerButtons,
  doNotShowAgainText,
  onDoNotShowAgainChange,
  contentClassName,
  isFullscreen: userProvidedIsFullscreen,
  ...rest
}) => {
  const isMobile = useContext(MobileContext);
  const isFullscreen = userProvidedIsFullscreen ?? (isMobile || false);
  return (
    <ModalRoot isFullscreen={isFullscreen} {...rest}>
      {variant === 'horizontal' ? (
        <HorizontalLayout
          image={image}
          title={title}
          message={message}
          contentClassName={contentClassName}
          footerLeft={[
            onDoNotShowAgainChange && (
              <ModalDoNotShowAgain
                key="dns"
                doNotShowAgainText={doNotShowAgainText || ''}
                onDoNotShowAgainChange={onDoNotShowAgainChange}
              />
            ),
          ]}
          footerRight={footerButtons}
          isFullscreen={isFullscreen}
        />
      ) : (
        <VerticalLayout
          image={image}
          title={title}
          message={message}
          contentClassName={contentClassName}
          footerButtons={footerButtons}
          footerExtras={
            onDoNotShowAgainChange && (
              <ModalDoNotShowAgain
                key="dns"
                doNotShowAgainText={doNotShowAgainText || ''}
                onDoNotShowAgainChange={onDoNotShowAgainChange}
              />
            )
          }
          isFullscreen={isFullscreen}
        />
      )}
    </ModalRoot>
  );
};
MessageModal.displayName = 'MessageModal';

export default MessageModal;
